<template>
  <div class="form-group">
    <label for="product">Choose Product:</label>
    <select
      id="product"
      ref="product"
      v-model="selectedItemId"
      name="product"
      class="form-control toggle-required required"
      required
      @change="productSelected"
    >
      <option
        v-for="(label, item_id) in productOptions"
        :key="item_id"
        :value="item_id"
        :selected="item_id === firstItemId"
      >
        {{ label }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store/stores";

export default {
  name: "GetProductSelect",
  store,
  data() {
    return {
      selectedItemId: "",
    };
  },
  computed: {
    ...mapState(["testdrive"]),
    productOptions: () => {
      return store.state.testdrive.products;
    },
    firstItemId: () => {
      return Object.keys(store.state.testdrive.products)[0];
    },
    selectedSubscriberIdChangedTo: () => {
      return store.state.testdrive.selectedSubscriberId;
    },
  },

  watch: {
    selectedSubscriberIdChangedTo() {
      this.selectedItemId = this.setProductId();
      this.$emit("product-selected", this.selectedItemId);
    },
  },
  created() {
    this.getProducts();
  },
  methods: {
    getProducts() {
      this.$store.dispatch("testdrive/getProducts");
    },
    productSelected(event, itemId = this.selectedItemId) {
      this.$emit("product-selected", itemId);
    },
    setProductId() {
      if (!this.selectedSubscriberIdChangedTo) {
        return "";
      }

      const thisSubscriber = this.testdrive.subscribers.find(
        (subscriber) => subscriber.id === this.selectedSubscriberIdChangedTo
      );

      const product = Object.entries(this.testdrive.products).filter(
        (idProductArray) => idProductArray[1] === thisSubscriber.product_name
      );

      return product[0][0];
    },
  },
};
</script>

<style scoped></style>
